import { createEntityAdapter } from '@reduxjs/toolkit';
import { CategoryI } from '@tacans/shared-marketplace-layer';

export const CategoryAdapter = createEntityAdapter<CategoryI>({
  selectId: (category) => category.id
});
